import classnames from 'classnames';
import React from 'react';
import { fromNow, utc2local } from '../_util/day';
import { pickDomAttrs } from '../_util/utils';
import Tooltip from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const FromNow = _ref => {
  let {
    targetDate,
    level,
    noDateTip,
    className,
    style,
    ...restProps
  } = _ref;
  const attrs = pickDomAttrs(restProps);
  if (!targetDate) {
    if (noDateTip) {
      return /*#__PURE__*/_jsx(Tooltip, {
        ...noDateTip,
        children: /*#__PURE__*/_jsx("span", {
          ...attrs.data,
          className: className,
          style: style,
          children: "-"
        })
      });
    } else {
      return /*#__PURE__*/_jsx("span", {
        ...attrs.data,
        children: "-"
      });
    }
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: utc2local(targetDate),
    children: /*#__PURE__*/_jsx("span", {
      ...attrs.data,
      className: classnames('fromNow', level, className),
      style: style,
      children: fromNow(targetDate)
    })
  });
};